import Vue from 'vue'
import VueRouter from 'vue-router'
import mainApp from '../mainApp.vue'

Vue.use(VueRouter)

const routes= [
  {
    path: '*',
    meta: {
      title: '登录'
    },
    name: 'binding',
    component: resolve => require(['../components/binding/binding.vue'], resolve)
  },
  {
    path: '/liquidWaste/scanCode',
    meta:{
      title:'填写标签',
    },
    name:'liquidWaste_scanCode',
    component: resolve => require(['../components/liquidWaste/scanCode/index.vue'], resolve)
  },
  // {
  //   path: '/liquidWaste/scanCode/sureInfo',
  //   meta:{
  //     title:'确认信息',
  //   },
  //   name:'liquidWaste_scanCode',
  //   component: resolve => require(['../components/liquidWaste/scanCode/sureInfo.vue'], resolve)
  // },
  {
    path: '/list',
    component: mainApp,
    meta:{
    },
    children: [
      {
        meta:{
          title:'清单',
        },
        path: '',
        name:'list',
        component: () => import('../components/index/index.vue')
      }
    ]
  },
  // {
  //   path: '/list',
  //   meta: {
  //     title: '清单'
  //   },
  //   name: 'list',
  //   component: resolve => require(['../components/index/index.vue'], resolve)
  // },
  {
    path: '/operation',
    meta: {
      title: '操作记录详情'
    },
    name: 'operation',
    component: resolve => require(['../components/index/operation/index.vue'], resolve)
  },
  {
    path: '/receive',
    meta: {
      title: '领用试剂'
    },
    name: 'receive',
    component: resolve => require(['../components/index/receive/index.vue'], resolve)
  },
  {
    path: '/giveBack',
    meta: {
      title: '归还试剂'
    },
    name: 'giveBack',
    component: resolve => require(['../components/index/giveBack/index.vue'], resolve)
  },
  {
    path: '/inStorage',
    meta: {
      title: '入库试剂'
    },
    name: 'inStorage',
    component: resolve => require(['../components/index/inStorage/index.vue'], resolve)
  },
  {
    path: '/inStorage/sure',
    meta: {
      title: '确认入库'
    },
    name: 'inStorage_sure',
    component: resolve => require(['../components/index/inStorage/sure.vue'], resolve)
  },
  {
    path: '/warn',
    component: mainApp,
    meta:{
    },
    children: [
      {
        meta:{
          title:'警报',
        },
        path: '',
        name:'warn',
        component: () => import('../components/warn/warn.vue')
      }
    ]
  },
  // {
  //   path: '/warn',
  //   meta: {
  //     title: '警报'
  //   },
  //   name: 'warn',
  //   component: resolve => require(['../components/warn/warn.vue'], resolve)
  // },
  {
    path: '/scrap',
    component: mainApp,
    meta:{
    },
    children: [
      {
        meta:{
          title:'报废',
        },
        path: '',
        name:'scrap',
        component: () => import('../components/scrap/scrap.vue')
      }
    ]
  },
  // {
  //   path: '/scrap',
  //   meta: {
  //     title: '报废'
  //   },
  //   name: 'scrap',
  //   component: resolve => require(['../components/scrap/scrap.vue'], resolve)
  // },
  {
    path: '/mine',
    component: mainApp,
    meta:{
    },
    children: [
      {
        meta:{
          title:'我的',
        },
        path: '',
        name:'mine',
        component: () => import('../components/mine/mine.vue')
      }
    ]
  },
  {
    path: '/humanFace',
    meta: {
      title: '人脸上传'
    },
    name: 'humanFace',
    component: resolve => require(['../components/humanFace/index.vue'], resolve)
  },
  // {
  //   path: '/mine',
  //   meta: {
  //     title: '我的'
  //   },
  //   name: 'mine',
  //   component: resolve => require(['../components/mine/mine.vue'], resolve)
  // }
]

const router = new VueRouter({
  mode:'history',
  routes
})

router.beforeEach(async (to, from, next) => {
  if(to.meta.title){
    document.title=to.meta.title;
  }
  next();
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js